import { StyleSheet, Text, TextInput, View } from 'react-native'
import { corporateColor, lightBackground } from '../../../../../../theme/colors'
import { inputStyle } from '../../../../../../theme/inputs'
import { InitialInputVoiceSearch } from '../../../../../../components/VoiceSearch/InitialInput/InitialInput'
import { useTranslation } from 'react-i18next'

interface Props {
  values: string
  onChange: (value: string) => void
}

export const Comments = ({ values, onChange }: Props) => {
  const { t } = useTranslation()
  return (
    <View style={styles.containerText}>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 8 }}>
        <Text style={styles.commentsLabel}>{t('Comentarios')}</Text>
        <Text style={styles.optionalLabel}>(opcional)</Text>
      </View>

      <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
        <TextInput
          multiline
          onChangeText={onChange}
          value={values}
          maxLength={199}
          style={[inputStyle.basicInput, { height: 80, textAlignVertical: 'top', flex: 1 }]}
          placeholder={t('Escribe algo o deja un audio')}
          placeholderTextColor={lightBackground}
          returnKeyType='done'
          blurOnSubmit
        />
        <InitialInputVoiceSearch getSearchValue={onChange} placeholder='' />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  containerText: {
    marginVertical: 20,
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  commentsLabel: {
    color: corporateColor,
    fontSize: 18,
    fontWeight: '500',
    marginRight: 4,
  },
  optionalLabel: {
    color: corporateColor,
    fontSize: 18,
    fontWeight: '300',
    marginRight: 4,
  },
})
